'use client';
function getSeriesLabels(series) {
  if (!series) {
    return {};
  }
  return series.reduce((acc, item) => {
    acc[item.name] = item.label;
    return acc;
  }, {});
}

export { getSeriesLabels };
//# sourceMappingURL=get-series-labels.mjs.map
